import React from "react";
import CustomerDataTable from "../components/customer/CustomerDataTable";
import apiConfig from "../config/appConfig";

const Customers = () => {
  const apiUrl = apiConfig.endpoints.customers.paginated; // Replace with your backend API endpoint

  return <CustomerDataTable apiUrl={apiUrl} />;
};

export default Customers;
